import { render, staticRenderFns } from "./FallingAerialTech.vue?vue&type=template&id=6ba0ffaf&"
import script from "./FallingAerialTech.vue?vue&type=script&lang=ts&"
export * from "./FallingAerialTech.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports